import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import KogInputAutoCompleteCheckControlled from '@/main/components/shared/inputAutoCompleteCheck/inputAutoCompleteCheckControlled';
import { StatusRegisterEnum } from '@/main/services/enum/StatusRegisterEnum';
import { isNullUndefined } from '@/main/services/utils';
import { getBodyshops, resetReducerBodyshops, useBodyshopReducer } from '@/main/store/bodyshop';
import { GeneralVariableType, useDynamicFiltersExport } from './dynamicFiltersExport';

interface IVariableTypeBodyhopProps extends GeneralVariableType { }
function VariableTypeBodyhop({
  filter
}: IVariableTypeBodyhopProps) {
  const dispatch = useDispatch();
  const {
    keyReducer,
    findFieldIndexByGuidDynamicReportVariable,
    idScreen,
    watcherCountry
  } = useDynamicFiltersExport();
  const { isolated: bodyshopReducer } = useBodyshopReducer(keyReducer);
  const {
    control,
    resetField,
    setValue
  } = useFormContext();

  useEffect(() => {
    if (isNullUndefined(watcherCountry)) return;

    dispatch(getBodyshops({ guidCountry: String(watcherCountry.key), idStatusRegister: StatusRegisterEnum.Active }, keyReducer));

    return () => {
      dispatch(resetReducerBodyshops());
    }
  }, [JSON.stringify(watcherCountry?.key)])

  const disabledBodyshop = isNullUndefined(bodyshopReducer.data) || bodyshopReducer.data.length === 1
  const indexField = findFieldIndexByGuidDynamicReportVariable(filter.guidDynamicReportVariable);

  return (
    <>
      <KogInputAutoCompleteCheckControlled
        name={`filtersDinamics.${indexField}.value`}
        disableSelectAll
        control={control}
        options={bodyshopReducer.data || []}
        label={filter.responseServer.filterName}
        disabled={disabledBodyshop}
        isLoading={bodyshopReducer.isLoading}
        setValueCustom={setValue}
        controllerProps={{ rules: { required: filter.responseServer.mandatory } }}
        customInputProps={{ required: filter.responseServer.mandatory, id: idScreen('select-bodyshop') }}
        onChangeCustom={(value, optionChanged, reason) => { }}
      />
    </>
  )
}

export default VariableTypeBodyhop